import * as React from "react";
import {useEffect, useState} from "react";
import {UserTypeEnum} from "../../model/UserInfo.model";
import {withVerifyAccess} from "../common/withVerifyAccess";
import {ClientApi, IClient} from "../../api/ClientApi";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {AdminCreateClientComponent} from "./AdminCreateClient.component";
import {useParams} from "react-router";
import {useNavigate} from "react-router-dom";
import {navigateTo} from "../../../navigateTo";

export const AdminEditClientPage: React.FunctionComponent = () => {
    const [client, setClient] = useState<IClient | undefined>(undefined);

    const { clientIdParam } = useParams();
    const clientId = Number.parseInt(clientIdParam!, 10);

    const navigate = useNavigate();

    useEffect(() => {
        ClientApi.requestClient(clientId).then((response) => {
            setClient(response);
        });
    }, [clientIdParam]);

    const cancelEdit = () => {
        navigateTo("/admin-client-plan", navigate);
    };

    const renderClient = () => {
        return client
            ? <div>
                <h2 className="admin-edit-client-page__client-name">{client.name}</h2>
                <AdminCreateClientComponent
                    onCancel={cancelEdit}
                    client={client}
                />
            </div>
            : <LoadingSpinner/>;
    };

    return <div className="page-container new-common-styles admin-edit-client-page__container">
        <h1 className="admin-edit-client-page__header">Edit Client</h1>
        {renderClient()}
    </div>;
};

export default withVerifyAccess(AdminEditClientPage, UserTypeEnum.ADMIN);